import { Controller } from 'stimulus';
import $ from 'jquery'

export default class extends Controller {
	static targets = ["query"]
  connect() {
    this.submit()
  }

  submit() {
   this.queryTarget.addEventListener('keyup', function(e){
  		var $rows = $('tr');
    	var val = $.trim(this.value);
    	if( val === ""){
    		$rows.show();
    	}
    	else{
    		$rows.hide();
    		$rows.has("th").show();
    		$rows.has("td:contains("+ val.charAt(0).toUpperCase() + val.slice(1).toLowerCase() +")").show();
			  $rows.has("td:contains("+ val.charAt(0).toLowerCase() + val.slice(1).toLowerCase() +")").show();
        $rows.has("td:contains("+ val.charAt(0).toUpperCase() + val.slice(1).toUpperCase() +")").show();
    	}

    })

  }

}